import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../utils/i18nRoutes';
import { siteContent } from '../config/siteContent';

export default function TrustStrip() {
  const location = useLocation();
  const isEn = isEnglishPath(location.pathname);
  const facts = isEn ? siteContent.trustFacts.en : siteContent.trustFacts.de;

  if (facts.length === 0) return null;

  return (
    <section className="py-10 px-6 bg-soft dark:bg-gray-800 border-y border-line dark:border-gray-700">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {facts.map((fact) => (
            <div
              key={fact.value}
              className="text-center px-4 py-4 bg-white dark:bg-gray-900 rounded-card border border-line dark:border-gray-700"
            >
              <div className="text-xl sm:text-2xl font-bold text-primary dark:text-accent-light mb-1">
                {fact.value}
              </div>
              <div className="text-xs sm:text-sm text-muted dark:text-gray-300 leading-snug">
                {fact.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
